import { Component } from 'react';
import { FiAlertTriangle, FiRefreshCw, FiHome } from 'react-icons/fi';
import logger from '../../utils/logger';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    logger.error('ErrorBoundary caught:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <main
          role="alert"
          className="min-h-screen flex items-center justify-center bg-gray-50 px-4"
        >
          <section className="bg-white border border-gray-200 rounded-lg p-8 max-w-md w-full text-center shadow-sm">
            <FiAlertTriangle className="text-6xl text-orange-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-black mb-2">Something went wrong</h1>
            <p className="text-black mb-6">
              An unexpected error occurred. Please try again or return to the homepage.
            </p>
            <nav className="flex gap-3 justify-center">
              <button
                onClick={this.handleReload}
                className="flex items-center gap-2 bg-orange-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-orange-700 transition"
              >
                <FiRefreshCw /> Reload
              </button>
              <button
                onClick={this.handleHome}
                className="flex items-center gap-2 border border-gray-300 text-black px-4 py-2 rounded-lg font-medium hover:bg-gray-50 transition"
              >
                <FiHome /> Home
              </button>
            </nav>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
